/**
 * --------------------------------------------------
 * Modal Module
 *
 * @module Modal
 * --------------------------------------------------
 */


export default {
  init() {
    // Open modal
    $('.rt-js-modal-trigger').on('click', function (e) {
        e.preventDefault();
        const targetId = $(this).data('target');
        const $modal = $('#' + targetId);

        if ($modal.length) {
            $modal.addClass('is-active');
        }
    });

    // Close modal (click on background or close button)
    $('.modal .modal-background, .modal .modal-close, .rt-js-modal-close').on('click', function () {
        const $modal = $(this).closest('.modal');
            if ($modal.length) {
                $modal.removeClass('is-active');
            }
        });
        // Close modal on Escape key
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $('.modal.is-active').removeClass('is-active');
            }
        });
    }
};
